import React, { Component } from "react";
import DefaultPicture from "../default-picture.png";
import mail from "../mail.png";
import phone from "../phone.png";

import "./AppUserData.css";

class AppUserData extends Component {
  constructor() {
    super();

    this.state = {
      data: null,
      token: null
    };
  }

  componentWillMount() {
    // Clear local storage
    localStorage.clear();
  }

  componentDidMount() {
    const t = this;
    let url_string = window.location.href;
    let url = new URL(url_string);
    let encryptedParams = url.searchParams.get("t");

    if (encryptedParams) {
      let DIAL_CROSS_GET_USER_DATA_URL =
        process.env.REACT_APP_DIALCROSS_SERVER_URL +
        "/" +
        process.env.REACT_APP_GET_USER_DATA +
        "?t=" +
        encodeURIComponent(encryptedParams);

      fetch(DIAL_CROSS_GET_USER_DATA_URL)
        .then(response =>
          response.json().then(data => {
            if (response.status === 200) {
              t.setState({
                data: data.userData
              });
              localStorage.setItem("dialcross-token", data.token);
            } else {
              t.setState({
                isAnErrorOccurred: true
              });
            }
          })
        )
        .catch(function(error) {
          console.log(
            "An error occurred during get user data request. \n\t Error : " +
              error
          );
          t.setState({
            isAnErrorOccurred: true
          });
        });
    } else {
      console.log("Cannot find params in URL.");
      t.setState({
        isAnErrorOccurred: true
      });
    }
  }

  render() {
    return (
      <div className=" square user-data no-pad bg-light" style={{ flex: 0.25 }}>
        {this.state.data &&
          this.state.data.wearer && (
            <Wearer
              wearerGivenName={this.state.data.wearer.given_name}
              wearerFamilyName={this.state.data.wearer.family_name}
              wearerBirthDate={this.state.data.wearer.birth_date}
              wearerEmail={this.state.data.wearer.email}
              wearerPhoneNumber={this.state.data.wearer.phone_number}
              wearerInfos={this.state.data.wearer.infos}
              wearerPhoto={this.state.data.wearer.avatar}
            />
          )}
        {this.state.data && (
          <FollowersList
            followers={this.state.data.followers}
            followersListLength={this.state.data.followers.length}
          />
        )}
        {/* {this.state.data &&
                <Owner ownerEmail={this.state.data.owner.email}
                        ownerFamilyName={this.state.data.owner.family_name}
                         ownerGivenName={this.state.data.owner.given_name}
                         ownerPhoneNumber={this.state.data.owner.phone_number}
                         ownerPicture={this.state.data.owner.avatar}
                    />
                } */}
        {this.state.isAnErrorOccurred && (
          <div className="text-light text-center">
            <p className="text-light text-center">
              Erreur lors du chargement des informations du porteur
            </p>
          </div>
        )}
        {!this.state.isAnErrorOccurred &&
          !this.state.data && (
            <div className="text-light text-center">
              <span className="text-light text-center">Chargement... </span>
            </div>
          )}
      </div>
    );
  }
}

function capitalizeFirstLetter(string) {
  if (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  } else {
    return "";
  }
}

const CENTERED = { justifyContent: "center", alignItems: "center" };

const Wearer = ({
  wearerGivenName,
  wearerFamilyName,
  wearerBirthDate,
  wearerEmail,
  wearerPhoneNumber,
  wearerInfos,
  wearerPhoto
}) => (
  <div className=" user-details wearer" style={{ backgroundColor: "#FFF" }}>
    <div className="row" style={{ ...CENTERED }}>
      <div className="col-12 user-image">
        <div className="wearerPictureContainer">
          {wearerPhoto && (
            <img
              src={wearerPhoto}
              alt="Suiveur"
              className="rounded-circle "
              style={{
                width: "100px",
                height: "100px",
                minWidth: "100px",
                minHeight: "100px"
              }}
            />
          )}
          {!wearerPhoto && (
            <img
              src={DefaultPicture}
              alt="Suiveur"
              className="rounded-circle"
              style={{
                width: "100px",
                height: "100px",
                minWidth: "100px",
                minHeight: "100px"
              }}
            />
          )}
        </div>
        <img
          src={DefaultPicture}
          className="img-responsive thumbnail"
          alt="Porteur"
        />
      </div>
      <div className="col-12">
        <div className="wearerSection">
          <p className="h2">
            {capitalizeFirstLetter(wearerGivenName) +
              " " +
              capitalizeFirstLetter(wearerFamilyName)}
          </p>
        </div>
        <div className="wearerSection">
          <strong className="h2">
            {wearerBirthDate}
            23 ans
          </strong>
        </div>
      </div>
    </div>
    <div class="height10" />

    <div className="col-12 row">
      <div className="col-12" style={{ paddingTop: 10 }}>
        {/* <i className="material-icons col-2 large no-pad" style={{float: "left", textAlign: "left", padding: 0}}>
                    email
                </i> */}
        <img
          src={mail}
          className="img-responsive thumbnail col-2 large no-pad"
          alt="Porteur"
          style={{ float: "left", textAlign: "left", padding: 0 }}
        />

        <p
          className="col-10 no-pad titleFirst h5"
          style={{
            float: "right",
            padding: 0,
            paddingLeft: "15px",
            paddingBottom: "0px",
            paddingTop: "0px"
          }}
        >
          {wearerEmail}
        </p>
      </div>
      <div class="height50" />
      <div className="col-12">
        <img
          src={phone}
          className="img-responsive thumbnail col-2 large no-pad"
          alt="Porteur"
          style={{ float: "left", textAlign: "left", paddingBottom: "10px" }}
        />
        <p
          className="col-10 no-pad h5"
          style={{ float: "right", paddingTop: "2px", paddingLeft: "15px" }}
        >
          {wearerPhoneNumber}
        </p>
      </div>
    </div>
    <div class="height10" />

    <div>
      <div className=" sectionContainer no-pad">
        <p className="h3">Commentaires</p>
      </div>
      <div style={{ height: "5px" }} />
      <p className="h5" style={{ paddingLeft: "20px" }}>
        {wearerInfos}
      </p>
    </div>
  </div>
);

const FollowersList = ({ followers, followersListLength }) => (
  <div className="col-12 bg-light no-pad text-dark followers">
    <div className="sectionContainer">
      <p className="col-12 no-pad h3">Référents</p>
    </div>
    {[...followers, ...followers].map((follower, index) => (
      <Follower
        follower={follower}
        key={follower.family_name + "" + follower.given_name + "" + index}
        index={index}
        followersListLength={followersListLength}
      />
    ))}
  </div>
);

const Follower = ({ follower, index, followersListLength }) => (
  <div className=" follower no-pad ">
    <div
      className="col-12  no-pad follower-identity"
      style={{ height: "80px" }}
    >
      <div className="col-4" style={{ float: "left" }}>
        {follower.avatar && (
          <img
            src={follower.avatar}
            alt="Suiveur"
            className="rounded-circle "
            style={{
              width: "60px",
              height: "60px",
              minWidth: "60px",
              minHeight: "60px"
            }}
          />
        )}
        {!follower.avatar && (
          <img
            src={DefaultPicture}
            alt="Suiveur"
            className="rounded-circle"
            style={{
              width: "60px",
              height: "60px",
              minWidth: "60px",
              minHeight: "60px"
            }}
          />
        )}
      </div>
      <div className="col-8 h2 no-pad" style={{ float: "right" }}>
        <strong>
          {capitalizeFirstLetter(follower.given_name) + " "}
          <br />
          {capitalizeFirstLetter(follower.family_name)}
        </strong>
        <br />
      </div>
    </div>

    <div className="col-12 h5 ">
      <div className="col-12 no-pad " style={{ height: 30 }}>
        {/* <i className="material-icons col-2 large no-pad" style={{float: "left", textAlign: "left", padding: 0}}>
                    email
                </i> */}
        <img
          src={mail}
          className="img-responsive thumbnail col-2 large no-pad"
          alt="Porteur"
          style={{ float: "left", textAlign: "left", padding: 0 }}
        />

        <span
          className="col-10 no-pad titleFirst"
          style={{ float: "right", paddingLeft: "15px", paddingTop: "0px" }}
        >
          {follower.email}
        </span>
      </div>

      <div
        className="col-12 no-pad "
        style={{ height: 45, marginTop: "10px", marginBottom: "5px" }}
      >
        <img
          src={phone}
          className="img-responsive thumbnail col-2 large no-pad"
          alt="Porteur"
          style={{ float: "left", textAlign: "left", paddingBottom: "0px" }}
        />
        <span
          className="col-10 no-pad"
          style={{ float: "right", paddingTop: "8px", paddingLeft: "15px" }}
        >
          {follower.phone_number}
        </span>
      </div>
    </div>

    {followersListLength !== index + 1 && <hr />}
  </div>
);

// const Owner = ({ownerGivenName, ownerFamilyName, ownerEmail, ownerPhoneNumber, ownerPicture}) => <div
//     className="col-12 no-pad owner bg-light text-dark">
//     <div className="sectionContainer">
//         <p className="h3">Propriétaire du Dial</p>
//     </div>

//     <div className="col-12  no-pad follower-identity" style={{height: "80px"}}>
//         <div className="col-4" style={{float: "left"}}>
//             {
//                 ownerPicture &&
//                 <img src={ownerPicture} alt="Suiveur" className="rounded-circle "
//                      style={{width: "60px", height: "60px", minWidth: "60px", minHeight: "60px"}}/>
//             }
//             {
//                 !ownerPicture &&
//                 <img src={DefaultPicture} alt="Suiveur" className="rounded-circle"
//                      style={{width: "60px", height: "60px", minWidth: "60px", minHeight: "60px"}}/>
//             }
//         </div>
//         <div className="col-8 h2  no-pad" style={{float: "right"}}>
//             <p>
//                 {capitalizeFirstLetter(ownerGivenName)+ " "} <br>
//                 </br>
//                 {ownerFamilyName}
//             </p>
//         </div>
//     </div>
//     <div className="col-12 h5 "  >
//             <div className="col-12 no-pad" style={{height:30}}>
//                 {/* <i className="material-icons col-2 large no-pad" style={{float: "left", textAlign: "left", padding: 0}}>
//                     email
//                 </i> */}
//                 <img src={mail} className="img-responsive thumbnail col-2 large no-pad" alt="Porteur"
//                 style={{float: "left", textAlign: "left", padding: 0 }}/>

//                 <span className="col-10 no-pad titleFirst" style={{float: "right", paddingLeft: "15px", paddingTop: "4px"}}>
//                 {ownerEmail}
//                 </span>
//             </div>

//                 <div className="col-12 no-pad" style={{height:45, marginTop:"10px"}}>
//                     <img src={phone} className="img-responsive thumbnail col-2 large no-pad" alt="Porteur"
//                         style={{float: "left", textAlign: "left", paddingBottom: "0px" }}/>
//                     <span className="col-10 no-pad" style={{float: "right", paddingTop:"15px", paddingLeft: "15px"}}>
//                             {ownerPhoneNumber}
//                     </span>
//                 </div>
//             </div>
//     </div>;

export default AppUserData;
